import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ComponentFactoryResolver, EventEmitter,
  OnInit, Output,
  ViewChild, ViewContainerRef,
} from '@angular/core';
import {Toast, ToasterService} from '../toaster-service/toaster.service';
import {ToasterComponent} from './toaster.component';

@Component({
  selector: 'app-toaster-container',
  template: '<ng-template #toasterViewContainerRef ></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./toaster.component.css'],
})
export class ToasterContainerComponent implements OnInit {
  @ViewChild('toasterViewContainerRef', {read: ViewContainerRef}) toasterViewContainerRef: ViewContainerRef | undefined;
  @Output() styleEmitter = new EventEmitter<string>();

  toasterReferences: any[] = [];
  index = 0;
  maxNumberOfToasters = 4;

  constructor(private toasterService: ToasterService, private changeRef: ChangeDetectorRef,
              private componentFactoryResolver: ComponentFactoryResolver) {
  }

  ngOnInit() {
    this.toasterService.change.subscribe((toast: Toast) => {
      this.addToaster(toast);
    });
  }

  addToaster(toast: Toast) {
    // Create component dynamically inside the ng-template
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ToasterComponent);
    // @ts-ignore
    const component = this.toasterViewContainerRef.createComponent(componentFactory);
    const currentComponent = component.instance;
    // @ts-ignore
    currentComponent.parent = this;
    currentComponent.index = ++this.index;
    currentComponent.fillToaster(toast);
    this.changeRef.detectChanges();
    // Push the component so that we can keep track of which components are created
    this.toasterReferences.push(component);
    if (this.toasterReferences.length > this.maxNumberOfToasters) {
      const firstToaster = this.toasterReferences[0].instance as ToasterComponent;
      firstToaster.closeToaster();
    }
  }

  public removeToaster(toaster: ToasterComponent) {
    // Find the component
    // @ts-ignore
    if (this.toasterViewContainerRef.length < 1) {
      return;
    }
    const thisToasterReference = this.toasterReferences.filter((toasterReference) =>
      toasterReference.instance.index === toaster.index)[0];

    // @ts-ignore
    const containerIndex: number = this.toasterViewContainerRef.indexOf(thisToasterReference);

    // removing component from container
    // @ts-ignore
    this.toasterViewContainerRef.remove(containerIndex);
    this.toasterReferences = this.toasterReferences.filter((x) => x.instance.index !== toaster.index);
    this.changeRef.detectChanges();
  }

}
